<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-novelinfo__novelinfo}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.novelCode" placeholder="小说ID" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('novelinfo:novelinfo:save')" type="primary" @click="add()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('novelinfo:novelinfo:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="chapterCode" label="小说章节ID" header-align="center" align="center"></el-table-column>
        <el-table-column prop="chapterName" label="章节名" header-align="center" align="center"></el-table-column>
        <el-table-column prop="type" label="是否收费" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.type == 0" type="success">免费</el-tag>
            <el-tag v-if="scope.row.type == 1" type="success">收费</el-tag>
        </template>
        </el-table-column>

        <el-table-column prop="novelName" label="小说名字" header-align="center" align="center"></el-table-column>
        <el-table-column prop="sortNum" label="下标" header-align="center" align="center"></el-table-column>
        <el-table-column prop="dictName" label="所属分类" header-align="center" align="center"></el-table-column>
        <el-table-column prop="createTime" label="入库时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="updateTime" label="更新时间" header-align="center" align="center"></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('novelinfo:novelinfo:update')" type="text" size="small" @click="addorupdateHandleNovelInfo(scope.row.chapterCode)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('novelinfo:novelinfo:delete')" type="text" size="small" @click="deleteHandle(scope.row.chapterCode)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="refreshDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './novelinfo-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/novelinfo/novelinfo/page',
        getDataListIsPage: true,
        createdIsNeed: false,
        exportURL: '/novelinfo/novelinfo/export',
        deleteURL: '/novelinfo/novelinfo',
        deleteIsBatch: true
      },
      dataForm: {
        novelCode: ''
      }
    }
  },
  watch: { // 监听，当路由发生变化的时候执行
        $route(to, from){
          if(this.$route.query.novelCode){
            if(this.dataForm.novelCode != this.$route.query.novelCode){
              this.dataForm.novelCode = this.$route.query.novelCode;
            this.getDataList()
            }
           
          }
        },
    },
  mounted(){
    this.dataForm.novelCode = this.$route.query.novelCode;
    this.getDataList()
  },
  components: {
    AddOrUpdate
  },
  methods:{
    add(){
      localStorage.setItem("novelCode",this.dataForm.novelCode);
      this.addorupdateHandleNovelInfo()
     
    },
    text(){
      this.$router.push({path:'novelinfo-noveltext'})
    }
  }
}
</script>
